/* (c) Alpas Made LLC. All rights reserved. */
/* Ring configurator cart bundle handling, v1.0.0.
   Removes all cart lines sharing a _bundleId together. Delegated on document so it
   survives the theme's wholesale cart-drawer re-renders. */
(function () {
  'use strict';
  var routes = window.routes || {};

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function drawerSectionId() {
    var d = document.querySelector('#CartDrawer');
    return d && d.dataset ? d.dataset.sectionId : null;
  }

  // Bundle-aware count: a configured ring bundle (lines sharing a _bundleId) counts as one;
  // add-on child lines (a _bundleId but no Ring size) are not counted. Mirrors cart-bundle-count.liquid.
  function bundleAwareCount(cart) {
    var n = 0;
    var items = (cart && cart.items) ? cart.items : [];
    items.forEach(function (it) {
      var b = it.properties && it.properties._bundleId;
      if (!b) { n += it.quantity; }
      else if (it.properties['Ring size']) { n += it.quantity; }
    });
    return n;
  }

  function updateCartCount(state) {
    var count = bundleAwareCount(state);
    Array.prototype.forEach.call(document.querySelectorAll('#CartCount .cart-count'), function (inner) {
      inner.innerHTML = count > 0 ? '<span aria-hidden="true">' + count + '</span>' : '';
    });
  }

  function rerender(state) {
    var drawer = document.querySelector('#CartDrawer');
    var sid = drawerSectionId();
    var sectionHTML = (sid && state && state.sections) ? state.sections[sid] : null;
    if (!drawer || !sectionHTML) { window.location.reload(); return; }
    try {
      var parsed = new DOMParser().parseFromString(sectionHTML, 'text/html');
      // Reuse the theme's own smooth cart-drawer refresh (keeps the drawer open, morphs content).
      if (typeof drawer.getTemplateContent === 'function' && typeof drawer.mount === 'function' && typeof drawer.emit === 'function') {
        drawer.lastDrawerBody = drawer.getTemplateContent(parsed);
        drawer.mount();
        drawer.emit('update-nodes', { node: drawer.lastDrawerBody });
        if (typeof drawer.updateEmptyStatus === 'function') { drawer.updateEmptyStatus(); }
      } else {
        var fresh = parsed.querySelector('#CartDrawer');
        if (fresh) { drawer.innerHTML = fresh.innerHTML; }
      }
      updateCartCount(state);
    } catch (e) {
      console.error('[RingBundle] rerender failed:', e);
      window.location.reload();
    }
  }

  function removeBundle(bundleId, trigger) {
    if (!bundleId) { return; }
    // Animate the visible ring card out, like the theme's native remove.
    var card = (trigger && trigger.closest) ? trigger.closest('cart-item') : null;
    if (card && typeof card.removeItem === 'function') { try { card.removeItem(); } catch (e) {} }
    else if (trigger) { trigger.setAttribute('disabled', 'disabled'); }
    getCart().then(function (cart) {
      var updates = {}, found = false;
      cart.items.forEach(function (it) {
        if (it.properties && it.properties._bundleId === bundleId) { updates[it.key] = 0; found = true; }
      });
      if (!found) { return; }
      var body = { updates: updates };
      var sid = drawerSectionId();
      if (sid) { body.sections = sid; body.sections_url = window.location.pathname; }
      return fetch(routes.cart_update_url || '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(rerender);
    }).catch(function (e) {
      console.error('[RingBundle] remove failed:', e);
      window.location.reload();
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-bundle-remove]') : null;
    if (!btn) { return; }
    e.preventDefault();
    e.stopPropagation();
    removeBundle(btn.getAttribute('data-bundle-id'), btn);
  }, true);
})();
